import {MembersPageState} from '../types/state'

export const isDemoMode = (state: MembersPageState) => state.view.demo

export const isNoEventsMode = (state: MembersPageState) => state.view.noEvents
